"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputWithLabel = exports._InputWithLabel = void 0;
var react_1 = __importDefault(require("react"));
var ErrorMessage_1 = require("../../../utils/ErrorMessage");
var with_form_manager_1 = require("../../../utils/with-form-manager");
var form_field_set_component_1 = require("../../base/form-field-set/form-field-set-component");
var input_component_1 = require("../../base/input/input-component");
var label_component_1 = require("../../base/label/label-component");
var _InputWithLabel = function (_a) {
    var _b = _a.formFieldSetProps, formFieldSetProps = _b === void 0 ? {} : _b, _c = _a.inputProps, inputProps = _c === void 0 ? {} : _c, _d = _a.labelProps, labelProps = _d === void 0 ? {} : _d, id = _a.id, name = _a.name, children = _a.children, tooltip = _a.tooltip, placeholder = _a.placeholder, maxCharacters = _a.maxCharacters, formManagerProps = __rest(_a, ["formFieldSetProps", "inputProps", "labelProps", "id", "name", "children", "tooltip", "placeholder", "maxCharacters"]);
    var labelRef = react_1.default.useRef(null);
    var inputRef = react_1.default.useRef(null);
    var isFocused = true;
    var error = formManagerProps.error, errorMessage = formManagerProps.errorMessage, extraInputProps = __rest(formManagerProps, ["error", "errorMessage"]);
    var hasError = error;
    var errorMessageText = errorMessage;
    if (typeof maxCharacters !== "undefined" &&
        formManagerProps.value &&
        formManagerProps.value.length >= maxCharacters) {
        inputProps.onKeyDown = function (e) {
            if (!e.ctrlKey && !e.metaKey && !e.altKey && e.key.length === 1) {
                e.preventDefault();
            }
        };
        // NOTE: we also have a inputProps.onPaste inside the FE repo in Question.tsx
        // I was unable to add it here, because I was not sure how to only allow the user
        // to paste in a certain amount of characters that were available
        if (!hasError) {
            errorMessageText = "You have reached the maximum number of characters allowed (" + maxCharacters + ").";
            hasError = true;
        }
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(form_field_set_component_1.FormFieldSet, __assign({}, formFieldSetProps, { hasError: hasError }),
            react_1.default.createElement(label_component_1.Label, __assign({ htmlFor: id, ref: labelRef, isFocused: isFocused }, labelProps, { hasError: hasError }),
                react_1.default.createElement("div", { className: "w-full" },
                    react_1.default.createElement("span", { className: "block" }, children),
                    tooltip && (react_1.default.createElement("span", { className: "block fs12 font-light mt-1 translate" }, tooltip)))),
            react_1.default.createElement(input_component_1.Input, __assign({ id: id, name: name, ref: inputRef, isFocused: isFocused, hasError: hasError, style: { outline: "none" }, placeholder: placeholder }, inputProps, extraInputProps))),
        errorMessageText && react_1.default.createElement(ErrorMessage_1.ErrorMessage, null, errorMessageText)));
};
exports._InputWithLabel = _InputWithLabel;
// const base = "fs14 w-full bg-white border-0 rounded-md block outline-none";
// const notFocused = "p-3";
// const focus = "pl-3 pb-2 pr-3";
// const getClasses = ({ isFocused }: { isFocused: boolean }) => {
//   return classNames(base, {
//     [focus]: isFocused,
//     [notFocused]: !isFocused,
//   });
// };
exports.InputWithLabel = Object.assign(exports._InputWithLabel, {
    css: {
    // base,
    // notFocused,
    // focus,
    },
    WithFormManager: (0, with_form_manager_1.withFormManager)(exports._InputWithLabel),
    displayName: "VistoInputWithLabel",
});
